export const types = {
  ACTION_LOGIN_SUCCESS: 'ACTION_LOGIN_SUCCESS',
  ACTION_LOGIN_FAILED: 'ACTION_LOGIN_FAILED',
  ACTION_SET_LOGIN_SECOND_FACTOR_STATUS: 'ACTION_SET_LOGIN_SECOND_FACTOR_STATUS',
  ACTION_LOGOUT_SUCCESS: 'ACTION_LOGOUT_SUCCESS',
  ACTION_OPEN_LOGIN_2FA_FORM: 'ACTION_OPEN_LOGIN_2FA_FORM',
  ACTION_HIDE_LOGIN_2FA_FORM: 'ACTION_HIDE_LOGIN_2FA_FORM',
  ACTION_SET_AUTH_CODE_CHECKED_STATUS: 'ACTION_SET_AUTH_CODE_CHECKED_STATUS',
};
